import { motion, useReducedMotion } from "framer-motion";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import Offer1 from "../../../assets/images/offer_1.webp";
import Offer2 from "../../../assets/images/offer_2.webp";
import Offer3 from "../../../assets/images/offer_3.webp";

const offerCards = [
  {
    id: "offer-20",
    image: Offer1,
    link: "/collections",
  },
  {
    id: "offer-50",
    image: Offer2,
    link: "/collections",
  },
  {
    id: "offer-30",
    image: Offer3,
    link: "/collections",
  },
];

const OfferBanner = () => {
  const shouldReduceMotion = useReducedMotion();

  const sectionVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.12,
        delayChildren: shouldReduceMotion ? 0 : 0.08,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: shouldReduceMotion ? 0 : 18 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceMotion ? 0.2 : 0.6,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  return (
    <section className="offer pt-80 mb-80">
      <div className="container container-lg">
        <motion.div
          variants={sectionVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.25 }}
        >
          <div className="position-relative">
            <Swiper
              modules={[Autoplay, Pagination]}
              slidesPerView={1.2}
              spaceBetween={16}
              loop={true}
              autoplay={{ delay: 4000, disableOnInteraction: false }}
              pagination={{
                el: ".offer-banner-swiper-pagination",
                clickable: true,
              }}
              breakpoints={{
                768: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                  autoplay: false,
                },
              }}
              className="offer-banner-swiper"
            >
              {offerCards.map((card) => (
                <SwiperSlide key={card.id}>
                  <motion.div variants={cardVariants}>
                    <Link to={card.link}>
                      <motion.div
                        className="offer-card position-relative rounded-16 overflow-hidden cursor-pointer"
                        whileHover={
                          shouldReduceMotion
                            ? undefined
                            : {
                                y: -8,
                                boxShadow:
                                  "0 20px 40px rgba(0, 0, 0, 0.15)",
                              }
                        }
                        transition={{ duration: 0.3, ease: "easeOut" }}
                      >
                        <motion.img
                          src={card.image}
                          alt=""
                          className="w-100 h-auto"
                          whileHover={
                            shouldReduceMotion
                              ? undefined
                              : { scale: 1.05 }
                          }
                          transition={{ duration: 0.4, ease: "easeOut" }}
                        />
                      </motion.div>
                    </Link>
                  </motion.div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="offer-banner-swiper-pagination" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
export default OfferBanner;
